import helpers from "@/helpers";
import { datiViaggio } from "@/models/carrello/datiViaggio";
import { CarrelloInfoProdotto } from "@/models/carrello/infoProdotto";
import { Component, Prop } from "vue-property-decorator";
import { mapMutations, mapState } from "vuex";
import baseContextComponent from "./baseContextComponent";

@Component({
	computed: {
		...mapState({
			datiViaggio: (state: any) => state.datiViaggio,
			prodottoSelezionato: (state: any) => state.prodottoSelezionato,
		})
	},
	methods: {
		...mapMutations(['setDatiViaggio'])
	}
})
export default class grigliaUlterioriDati extends baseContextComponent {
	gridData: any[] = [];
	indexUpdate: number = 0;

	@Prop({ default: () => null }) ulterioriDati: any[];
	
	prodottoSelezionato!: CarrelloInfoProdotto;
	datiViaggio!: datiViaggio;
	setDatiViaggio!: (setDatiViaggio: datiViaggio) => void;

	updateUlterioriDati() {
		this.datiViaggio.ulterioriDati = helpers.cloneObject(this.gridData)
		this.setDatiViaggio(this.datiViaggio);
		this.indexUpdate++;
	}

	created() {
		this.initUlterioriDati();
	}

	initUlterioriDati(){
		//this.gridData =  this.ulterioriDati.map(obj => {return { ItemID: obj.itemID, Valore: ''}});
		this.gridData = helpers.cloneObject(this.ulterioriDati)

		if(this.datiViaggio && this.datiViaggio.ulterioriDati && this.datiViaggio.ulterioriDati.length){
			for(var i = 0; i < this.datiViaggio.ulterioriDati.length; i++){
				var u = this.gridData.find(obj => obj.itemID === this.datiViaggio.ulterioriDati[i].itemID );
				u && (u.valore = this.datiViaggio.ulterioriDati[i].valore );
			}
		}
		this.updateUlterioriDati();
	}

	beforeDestroy() {
		this.$root.$off("updateUlterioriDati");
	}
	mounted() {
		var self = this;
		this.$root.$on("updateUlterioriDati", () => {
			self.updateUlterioriDati();
		});
	}

	validaDati(){
		var err = [];

		for(var i = 0; i < this.ulterioriDati.length; i++){
			if( this.ulterioriDati[i].obbligatorio){
				var u = this.datiViaggio.ulterioriDati.find( obj => obj.itemID == this.ulterioriDati[i].itemID);
				if( !u || !u.valore )
					err.push("Ulteriore dato obbligatorio: " + this.ulterioriDati[i].descrizione);
			}
		}
		return err;
	}
}
